import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import {
	useCancelPurchaseRequest,
	useListMyPurchaseRequests,
} from "@/api/marketplace/requests";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/marketplace/my-requests/",
)({
	component: MyRequestsPage,
});

function MyRequestsPage() {
	const { orgId } = Route.useParams();
	const { t } = useTranslation();
	const { data: requests, isLoading } = useListMyPurchaseRequests(orgId);
	const cancel = useCancelPurchaseRequest();

	return (
		<div className="space-y-4 p-4">
			<div className="flex items-center justify-between">
				<h1 className="text-xl font-semibold">
					{t("marketplace.myRequests.title")}
				</h1>
				<Button asChild variant="outline">
					<Link to="/app/org/$orgId/marketplace" params={{ orgId }}>
						{t("marketplace.myOffers.back")}
					</Link>
				</Button>
			</div>

			{isLoading && (
				<p className="text-muted-foreground">{t("common.loading")}</p>
			)}
			{!isLoading && (requests?.length ?? 0) === 0 && (
				<p className="text-muted-foreground">
					{t("marketplace.myRequests.empty")}
				</p>
			)}

			<div className="space-y-2">
				{requests?.map((req) => (
					<div
						key={req.id}
						className="flex flex-wrap items-center justify-between gap-2 rounded-lg border p-3"
					>
						<div>
							<p className="font-medium">
								{t("marketplace.myRequests.requestLabel", {
									id: req.id.slice(0, 8),
								})}
							</p>
							<p className="text-sm text-muted-foreground">
								{t("marketplace.status", {
									status: t(`marketplace.requestStatus.${req.status}`),
								})}
								{req.rejectionReason ? ` · ${req.rejectionReason}` : ""}
							</p>
						</div>
						{req.status === "PENDING" && (
							<Button
								size="sm"
								variant="outline"
								onClick={() =>
									cancel.mutate({
										organizationId: orgId,
										requestId: req.id,
									})
								}
							>
								{t("common.cancel")}
							</Button>
						)}
					</div>
				))}
			</div>
		</div>
	);
}
